import path from 'path';
import {
  AddPanelLightbox64Icon,
  ElementLightboxIcon,
} from '@packages/systems/spring';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import LightboxWrapper from './LightboxWrapper';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {typeName, qualify, iconName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EEnum,
  EList,
  ELiteral,
  EBoolean,
} from '@packages/systems/wfdl-ast';

import {LightboxImageType} from './dataTypes/LightboxImageType';
import {LightboxMediaType} from './dataTypes/LightboxMediaType';
import {LightboxImageAndCaptionType} from './dataTypes/LightboxImageAndCaptionType';

const LightboxAddPanelIcon = wrapAddPanelIcon(AddPanelLightbox64Icon);

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelLightbox: LightboxAddPanelIcon,
    Lightbox: ElementLightboxIcon,
  },

  atoms: {LightboxWrapper},

  dataTypes: {
    LightboxImageAndCaption: LightboxImageAndCaptionType,
    LightboxImage: LightboxImageType,
    LightboxMedia: LightboxMediaType,
  },

  elementPresets: {
    LightboxWrapper: ElementPreset.create({
      factory: EElement({
        id: 'Lightbox Wrapper',
        type: qualify(
          Plugins.name('Lightbox'),
          Component.name('LightboxWrapper')
        ),
        data: ERecord({
          lightbox: ERecord({
            type: EText('wrapper'),
          }),
          block: EText('inline'),
          attr: ERecord({
            href: EText('#'),
          }),
          json: ERecord({
            items: EList([]),
            group: EText(''),
          }),
          children: EList([
            EElement({
              id: 'Lightbox Wrapper Image',
              type: qualify(Plugins.name('Basic'), Component.name('Image')),
              data: ERecord({
                attr: ERecord({
                  src: EText(
                    'https://d3e54v103j8qbb.cloudfront.net/img/placeholder-thumb.svg'
                  ),
                  loading: EEnum('lazy'),
                  width: EText('auto'),
                  height: EText('auto'),
                  alt: EText('__wf_reserved_inherit'),
                }),
                img: ELiteral({
                  name: qualify(Plugins.name('Asset'), typeName('Image')),
                  value: {},
                }),
                temp: ERecord({
                  img: ERecord({
                    src: EText(''),
                  }),
                }),
                srcsetDisabled: EBoolean(false),
                sizes: EList([]),
              }),
            }),
          ]),
        }),
      }),
      icon: {
        small: qualify(Plugins.name('Lightbox'), iconName('Lightbox')),
        medium: qualify(Plugins.name('Lightbox'), iconName('AddPanelLightbox')),
      },
      label: 'Lightbox',
      helpData: {
        description: [
          'A Lightbox allows images and videos to display in a full-screen view on any device.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/lightbox.d51c8c66dd.mp4',
      },
      category: 'Media',
    }),
  },

  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-lightbox.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) =>
          data.lightbox && data.lightbox.type === 'wrapper',
      },
    },
  ],
});
